// src/components/ModeloFicha/ModeloFicha.jsx
import React from 'react';
import TagManager from 'react-gtm-module';
import styles from './ModeloFicha.module.scss';

const ModeloFicha = ({ modelo }) => {
  // URL configurada como variable
  const URL_FICHA = 'https://heyzine.com/flip-book/f34195a0ca.html#page/1';

  const handleDownload = () => {
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'modelo_ficha_tecnica',
          event_category: 'engagement',
          event_label: `Ficha Abierta - ${modelo.nombre}`,
          value: null,
          slug: null
        },
      });
    }
    // Abrimos la ficha en nueva pestaña usando la variable
    window.open(URL_FICHA, '_blank');
  };

  return (
    <div className={styles.modeloFicha}>
      <button
        type="button"
        className={styles.modeloFichaButton}
        onClick={handleDownload}
      >
        VER FICHA
      </button>
    </div>
  );
};

export default ModeloFicha;
